// extracted by mini-css-extract-plugin
module.exports = {"widgetFiles":"widget-demo--widgetFiles--2GVS9","widgetFilesMain":"widget-demo--widgetFilesMain--1cEgZ"};